import { render, staticRenderFns } from "./2fa.vue?vue&type=template&id=50eb6630&"
import script from "./2fa.vue?vue&type=script&lang=js&"
export * from "./2fa.vue?vue&type=script&lang=js&"
import style0 from "./2fa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "2fa.vue"
export default component.exports